import { Box } from '@mui/material';

import { Lock01Icon } from '@/components/icons/Lock01Icon';
import { Tooltip } from '@/components/poppers/Tooltip/Tooltip';
import { useIsElementHovered } from '@/hooks/useIsElementHovered';
import { COLORS } from '@/styles/tokens/colors';

/**
 * A security icon with a tooltip explaining the encryption used for files.
 * Used in the FileUploaderV2 component.
 */
export function FileUploaderSecurityIcon() {
  const [isHovered, props] = useIsElementHovered();
  return (
    <Tooltip title="Files are secured with enterprise-grade AES 256-bit encryption">
      <Box {...props}>
        <Lock01Icon
          size={14}
          color={
            isHovered ? COLORS.TEXT.SECONDARY_HOVER : COLORS.TEXT.SECONDARY
          }
        />
      </Box>
    </Tooltip>
  );
}
